module.exports = "/images/frau-3.jpg?6d7f42920faf0e8fb6803cdbb4bf1a1a";